/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ClimateGovernanceProcess } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ClimateGovernanceProcessGovernanceArtifactUpdateForm(
  props
) {
  const {
    id: idProp,
    climateGovernanceProcess: climateGovernanceProcessModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    GovernanceArtifactName: "",
    GovernanceArtifactDescription: "",
  };
  const [GovernanceArtifactName, setGovernanceArtifactName] = React.useState(
    initialValues.GovernanceArtifactName
  );
  const [GovernanceArtifactDescription, setGovernanceArtifactDescription] =
    React.useState(initialValues.GovernanceArtifactDescription);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = climateGovernanceProcessRecord
      ? { ...initialValues, ...climateGovernanceProcessRecord }
      : initialValues;
    setGovernanceArtifactName(cleanValues.GovernanceArtifactName);
    setGovernanceArtifactDescription(cleanValues.GovernanceArtifactDescription);
    setErrors({});
  };
  const [climateGovernanceProcessRecord, setClimateGovernanceProcessRecord] =
    React.useState(climateGovernanceProcessModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ClimateGovernanceProcess, idProp)
        : climateGovernanceProcessModelProp;
      setClimateGovernanceProcessRecord(record);
    };
    queryData();
  }, [idProp, climateGovernanceProcessModelProp]);
  React.useEffect(resetStateValues, [climateGovernanceProcessRecord]);
  const validations = {
    GovernanceArtifactName: [],
    GovernanceArtifactDescription: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          GovernanceArtifactName,
          GovernanceArtifactDescription,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ClimateGovernanceProcess.copyOf(
              climateGovernanceProcessRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "ClimateGovernanceProcessGovernanceArtifactUpdateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Governance Artifact"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 6 a i."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Update this record that defines how responsibilities for climate-related risks and opportunities are reflected in the terms of reference, mandates, role descriptions and other related policies applicable to that body(s) or individual(s)."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Governance artifact name (e.g. Climate governance Terms of Reference)"
        isRequired={false}
        isReadOnly={false}
        value={GovernanceArtifactName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              GovernanceArtifactName: value,
              GovernanceArtifactDescription,
            };
            const result = onChange(modelFields);
            value = result?.GovernanceArtifactName ?? value;
          }
          if (errors.GovernanceArtifactName?.hasError) {
            runValidationTasks("GovernanceArtifactName", value);
          }
          setGovernanceArtifactName(value);
        }}
        onBlur={() =>
          runValidationTasks("GovernanceArtifactName", GovernanceArtifactName)
        }
        errorMessage={errors.GovernanceArtifactName?.errorMessage}
        hasError={errors.GovernanceArtifactName?.hasError}
        {...getOverrideProps(overrides, "GovernanceArtifactName")}
      ></TextField>
      <TextAreaField
        label="Governance artifact description"
        isRequired={false}
        isReadOnly={false}
        value={GovernanceArtifactDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              GovernanceArtifactName,
              GovernanceArtifactDescription: value,
            };
            const result = onChange(modelFields);
            value = result?.GovernanceArtifactDescription ?? value;
          }
          if (errors.GovernanceArtifactDescription?.hasError) {
            runValidationTasks("GovernanceArtifactDescription", value);
          }
          setGovernanceArtifactDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "GovernanceArtifactDescription",
            GovernanceArtifactDescription
          )
        }
        errorMessage={errors.GovernanceArtifactDescription?.errorMessage}
        hasError={errors.GovernanceArtifactDescription?.hasError}
        {...getOverrideProps(overrides, "GovernanceArtifactDescription")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || climateGovernanceProcessModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || climateGovernanceProcessModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
